const PoStatus = {
  PENDING_RECEIPT: 'Pending Receipt',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  ACCEPT: 'accept',
  REVISED: 'revised',
  ACCEPT_REVISION: 'Accept revision',
};

export const PurchaseOrderStage = {
  ISSUED: 'Issued',
  BULK_PRODUCTION: 'Bulk Production',
  TOP: 'TOP',
  DELIVERY_SHIPPING: 'Delivery & Shipping',
  RECEIVING: 'Receiving',
  PAYMENT: 'Payment',
};

export const DeliveryShippingSubStage = {
  PENDING: 'Delivery Date: Pending',
  SCHEDULED: 'Delivery Date: Scheduled',
};

export default PoStatus;
